import React from 'react';
// import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from './routes';
// import Container from "react-bootstrap/Container";
// import "./assets/bootstrap.min.css";
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import './i18n';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from './bugsnag';
import { AppProviders } from './providers/AppProviders';

const App = () => {
  return (
    <ErrorBoundary>
      <AppProviders>
        <div>
          <AppRoutes />
          <ToastContainer />
        </div>
      </AppProviders>
    </ErrorBoundary>
  );
};

export default App;
